import { Stack, Text, TextInput } from "@mantine/core";
import { useDebouncedValue } from "@mantine/hooks";
import { useEffect, useRef, useState } from "react";
import { IconSearch } from "@tabler/icons-react";

type Props = {
  setSearch: (e: string) => void;
};

function SearchBox({ setSearch }: Props) {
  const [value, setValue] = useState("");
  const [debounced] = useDebouncedValue(value, 1000);
  const setSearchRef = useRef(setSearch);
  setSearchRef.current = setSearch;
  useEffect(() => {
    setSearchRef.current(debounced);
  }, [debounced]);

  return (
    <Stack gap="" mb="xs" pos="relative">
      <TextInput
        size="md"
        description=""
        placeholder="نام، شماره تلفن"
        value={value}
        styles={{
          input: {
            "&::placeholder": {
              fontSize: "0.7rem",
              fontWeight: "100",
            },
          },
        }}
        onChange={(event) => setValue(event.currentTarget.value)}
        rightSection={<IconSearch />}
      />

      {debounced && debounced.length > 0 && debounced?.length < 2 && (
        <Text size="xs" p="0" pos="absolute" bottom={-20} c="yellow">
          وارد کردن حداقل 2 کاراکتر برای جستجو الزامی می باشد
        </Text>
      )}
    </Stack>
  );
}

export default SearchBox;
